import {
    StyleSheet
} from "react-native";
import type {
    PaginationDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    table: {
        justifyContent: "space-between"
    },
    more: {
        justifyContent: "center",
        flexDirection: "column",
        flexWrap: "nowrap"
    },
    container: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    isTableLayout,
    spaces
}: PaginationDynamicStyleType) => {
    return {
        container: {
            columnGap: isTableLayout ? spaces.spacingLg : spaces.spacingMd,
            rowGap: spaces.spacingSm
        }
    };
};
export default stylesheet;
